/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { FxGamesLibWebRpcContractsResponseFromJSON, FxIdApplicationHandlersSupportSendMessageSendSupportMessageCommandToJSON, } from '../models/index';
/**
 *
 */
export class SupportApi extends runtime.BaseAPI {
    /**
     */
    async fxIdWebFeaturesSupportSendSupportMessageSendSupportMessageEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdApplicationHandlersSupportSendMessageSendSupportMessageCommand'] == null) {
            throw new runtime.RequiredError('fxIdApplicationHandlersSupportSendMessageSendSupportMessageCommand', 'Required parameter "fxIdApplicationHandlersSupportSendMessageSendSupportMessageCommand" was null or undefined when calling fxIdWebFeaturesSupportSendSupportMessageSendSupportMessageEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWTBearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/support/send-message`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdApplicationHandlersSupportSendMessageSendSupportMessageCommandToJSON(requestParameters['fxIdApplicationHandlersSupportSendMessageSendSupportMessageCommand']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxGamesLibWebRpcContractsResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesSupportSendSupportMessageSendSupportMessageEndpoint(fxIdApplicationHandlersSupportSendMessageSendSupportMessageCommand, initOverrides) {
        const response = await this.fxIdWebFeaturesSupportSendSupportMessageSendSupportMessageEndpointRaw({ fxIdApplicationHandlersSupportSendMessageSendSupportMessageCommand: fxIdApplicationHandlersSupportSendMessageSendSupportMessageCommand }, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=SupportApi.js.map